import { createSelector } from 'reselect'
import uiDataSelector from 'redux/selectors/ui/ui_data_selector'
import privateLibraryGetCurrentLibraryUIDSelector from 'redux/selectors/private_library/private_library_get_current_library_uid_selector'
import userPrivateLibrariesSelector from 'redux/selectors/user/user_private_libraries_selector'
import viewTypes from 'helpers/enums/viewTypes'

const getCurrentLibraryType = createSelector(
	[ uiDataSelector, privateLibraryGetCurrentLibraryUIDSelector, userPrivateLibrariesSelector ],
	(ui, libraryUID, libraries) => {
		if (ui.currentView === viewTypes.LIBRARY)
			return 'MyLibrary'

		const library = libraries.find(item => item.id == libraryUID)
		if (library) {
			switch (library.library_type) {
				case 'ayce':
					return 'Content Package'
				case 'school':
					return 'School Library'
				case 'district':
					return 'District Library'
				default:
					return ''
			}
		}

		return ''
	}
)

export default getCurrentLibraryType
